import { render, staticRenderFns } from "./aboutCenGywmTwo.vue?vue&type=template&id=829690cc&scoped=true"
import script from "./aboutCenGywmTwo.vue?vue&type=script&lang=js"
export * from "./aboutCenGywmTwo.vue?vue&type=script&lang=js"
import style1 from "./aboutCenGywmTwo.vue?vue&type=style&index=1&id=829690cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829690cc",
  null
  
)

export default component.exports